<template lang="pug">
.parent(v-bind:class="{ 'active': showLoader}")
   .spinner
</template>

<script>
export default {
  props: {
    showLoader: {
      data: Boolean,
      default: false
    }
  }
}
</script>

<style>
.parent {
    background-color: #ffffff4d;
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: none;
    top: 0;
    left: 0;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 100px auto;
  background-color: #333;
  top: 40%;
  position: relative;
  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

.active {
   display: inline;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Loader.vue